import _ from 'lodash'
import Services from '../../../service/ApiServices';
import { GetDateISOString } from '../../../utilities/DateHelper';

const CensusFormValidator = async (model)=>{ 

    let errors = {};
    let response = null;
    
    if (_.isEmpty(model.occupantType)) {           
        errors.occupantType = "Please choose occupant type.";
    }
    if (!_.get(model.client, "id")) {              
        errors.client = "Please choose client.";
    }   
    if (_.isNull(model.endDate)) {               
        errors.endDate = "Please choose end date.";
    }
    if (_.get(model.occupantType, "code") && _.isEqual(model.occupantType.code, "DEPENDENT") && _.isEmpty(model.dependentName)) {               
        errors.dependentName = "Please provide dependent name.";
    }    
    if(!_.isNull(model.endDate)  && _.get(model.client, "id"))  
    {
        response = await Services.Census.checkBedAvailability({...model, startDate:GetDateISOString(model.startDate), endDate:GetDateISOString(model.endDate)});
        if(!response.flag){
            errors.stayDuration = "Date range conflicts with existing reservation.";
        }
    }
    if(_.has(model, "building")){
        if(_.isNull(model.building)){
            errors.building = "Please choose a building"
        }
    }
    if(_.has(model, "parent")){
        if(!_.isEqual(model.parentType.code, "BUILDING") && _.isNull(model.parent)){
            errors.parent = `Please choose a ${model.parentType.name}`
        }
    }
    if(_.has(model, "room")){
        if(_.isNull(model.room)){
            errors.room = "Please choose a room"
        }
    }
    if(_.has(model, "bed")){
        if(_.isNull(model.bed)){
            errors.bed = "Please choose a bed"
        }
    }
    
    return errors;

}

export default CensusFormValidator;